import { Button } from 'antd'

import { useForm } from '@eastcoal/formily/exports/react'

import { PriceCompareFormData } from '../../../Create/interface'

export const GoodsResetButton = () => {
  const form = useForm<PriceCompareFormData>()

  const handleClick = () => {
    form.setValuesIn('goods', [])
  }

  return (
    <Button danger type='default' onClick={handleClick}>
      重置
    </Button>
  )
}
